import React from 'react'

function About() {
  return (
        <span className="pt-120" id="about">
            <section className="services__area">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            <div className="experience__box bg__radius">
                                <h1 className="big__text pos-rel">
                                    <span className="big__text--stock">15+</span>
                                    <span className="big__text--fill">15+</span>
                                </h1>
                                <h5 className="title">Years of Cumulative Expertise</h5>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="services__content mt-30 pl-90">
                                <div className="sec__title mb-30">
                                    <span className="sub__title"><i className="fas fa-star"></i>About Us</span>
                                    <h4 className="title_sm mb-25">Unlock the Power of Effective HR with TTN Consulting</h4>
                                    <p>Built on a foundation of 15 years of industry expertise, TTN Consulting is a dynamic 4-year-old firm delivering top-tier HR solutions tailored to your most pressing needs. </p>
                                    <p>Our client-centric approach ensures personalized strategies that foster growth and efficiency, Partner with us to experience unparalleled expertise and transformative results. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="features__area pt-120">
                <div className="container">
                    <div className="row justify-content-center mt-none-30">
                        <div className="col-lg-4 col-md-6">
                            <div className="features__single mt-30">
                                <div className="features__head mb-40 ul_li_between">
                                    <div className="feat__icon">
                                        <img src="assets/img/icon/feat_01.png" alt="" />
                                    </div>
                                    <span className="feat__number">01</span>
                                </div>
                                <h3 className="feat__title">Client-Centric Approach</h3>
                                <p>We prioritize understanding and fulfilling the unique needs of each client. This involves active listening, open communication, and tailored solutions that drive client success.</p>
                                {/* <a className="feat__link" href="service-details.html"><i className="far fa-arrow-right"></i></a> */}
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="features__single mt-30">
                                <div className="features__head mb-40 ul_li_between">
                                    <div className="feat__icon">
                                        <img src="assets/img/icon/feat_02.png" alt="" />
                                    </div>
                                    <span className="feat__number">02</span>
                                </div>
                                <h3 className="feat__title" style={{fontSize:"29px"}}>Integrity & Confidentiality</h3>
                                <p>We maintain the highest standards of integrity in all interactions, ensuring confidentiality and trust in our client relationships while handling sensitive HR matters with discretion.</p>
                                {/* <a className="feat__link" href="service-details.html"><i className="far fa-arrow-right"></i></a> */}
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="features__single mt-30">
                                <div className="features__head mb-40 ul_li_between">
                                    <div className="feat__icon">
                                        <img src="assets/img/icon/feat_03.png" alt="" />
                                    </div>
                                    <span className="feat__number">03</span>
                                </div>
                                <h3 className="feat__title">Results-Driven Excellence</h3>
                                <p>By setting clear objectives and benchmarks, we ensure our consulting services contribute directly to the success and growth of our clients' businesses.</p>
                                {/* <a className="feat__link" href="service-details.html"><i className="far fa-arrow-right"></i></a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </span>
            
  )
}

export default About
